import { parseSettlementStatus } from "../parseSettlementStatus";
import { EETAG } from "../../constants";
import { conditionalValue } from "../../helpers";
const mapEarlyExitTagTypeToDictKey = {
    None: () => [],
    Full: (dict) => [dict.myBetsDictionary.EarlyExitReturned],
    Applied: (dict, bet) => {
        var _a, _b;
        const status = parseSettlementStatus(bet.settlementStatus);
        const isGhostLegBonusApplicable = ((_a = bet.bonus) === null || _a === void 0 ? void 0 : _a.boostStatus) === "GuaranteedPayoutPending" || ((_b = bet.bonus) === null || _b === void 0 ? void 0 : _b.boostStatus) === "GuaranteedPayoutWon";
        if (!isGhostLegBonusApplicable && status === "Lost") {
            return [dict.myBetsDictionary.EarlyExitLost];
        }
        return [dict.myBetsDictionary.EarlyExitApplied];
    }
};
// eslint-disable-next-line complexity
export function parseTags(bet, dict) {
    var _a, _b, _c, _d;
    const EELabel = conditionalValue(!!bet.earlyExitStatus, dict.myBetsDictionary.EarlyExitProtected, dict.myBetsDictionary.EarlyExit);
    const messages = bet.earlyExitStatus ? mapEarlyExitTagTypeToDictKey[bet.earlyExitStatus](dict, bet) : [];
    const status = parseSettlementStatus(bet.settlementStatus);
    const isGhostLegBonusApplicable = ((_a = bet.bonus) === null || _a === void 0 ? void 0 : _a.boostStatus) === "GuaranteedPayoutPending" || ((_b = bet.bonus) === null || _b === void 0 ? void 0 : _b.boostStatus) === "GuaranteedPayoutWon";
    const isActive = isGhostLegBonusApplicable || (!!bet.earlyExitStatus || ((_c = bet.tags) === null || _c === void 0 ? void 0 : _c.includes(1))) && status !== "Lost";
    const tag = ((_d = bet.tags) === null || _d === void 0 ? void 0 : _d.includes(EETAG)) || (bet.earlyExitStatus !== undefined && bet.earlyExitStatus !== "None") ? { type: "earlyExit", label: EELabel, messages, isActive } : undefined;
    return tag;
}
export function parseTagsSelection(selection, dict) {
    const EELabel = selection.isEarlyExitApplied !== undefined ? dict.myBetsDictionary.EarlyExitProtected : dict.myBetsDictionary.EarlyExit;
    return { type: "earlyExit", label: EELabel };
}
//# sourceMappingURL=parseTags.js.map